import { render } from "./StandardHeader.vue?vue&type=template&id=48d560e1&scoped=true"
import script from "./StandardHeader.vue?vue&type=script&lang=js"
export * from "./StandardHeader.vue?vue&type=script&lang=js"

import "./StandardHeader.vue?vue&type=style&index=0&id=48d560e1&scoped=true&lang=css"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d560e1"]])

export default __exports__